import styled, { css } from 'styled-components';
import { MOBILE_BUTTON_TYPES } from './mobileMenuButton.constans';
import { getSectionColor } from '../tableOfContents.styles';
import { UI_COLORS, WHITE } from '../../../utils/colors';
import { media } from '../../../utils/media';
import { always, equals } from 'ramda';
import { propCond } from '../../../utils/propCond';
import { ZINDEX } from '../../../utils/constants';

const typeCond = propCond('type');

export const Bar = styled.span`
  width: 30px;
  height: 2px;
  background-color: ${UI_COLORS[2]};

  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;

export const Button = styled.button`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.6);
  width: 60px;
  height: 60px;
  position: fixed;
  left: 30px;
  top: 30px;
  border-radius: 100%;
  border: none;
  cursor: pointer;
  z-index: ${ZINDEX.MENU_MOBILE_BUTTON};

  font-size: 22.2px;
  font-weight: 600;
  color: ${WHITE};

  ${media.desktop`
    display: none;
  `}

  ${typeCond([
    [
      equals(MOBILE_BUTTON_TYPES.SECTION),
      always(css`
        background-color: ${(theme) => getSectionColor(theme.sectionIndex)};
      `),
    ],
    [
      equals(MOBILE_BUTTON_TYPES.NORMAL),
      always(css`
        background-color: ${WHITE};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `),
    ],
  ])}
`;
